import { render, staticRenderFns } from "./TitleBarCard.vue?vue&type=template&id=ca3a5030&scoped=true"
import script from "./TitleBarCard.vue?vue&type=script&lang=js"
export * from "./TitleBarCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3a5030",
  null
  
)

export default component.exports